export const QUERY_KEYS = {
  KILL_SWITCH: 'KILL_SWITCH',
  EXPERIMENTS: 'EXPERIMENTS',
  ADDRESS_BOOK: 'ADDRESS_BOOK',
  ADDRESS_BOOK_WHITELIST: 'ADDRESS_BOOK_WHITELIST',
} as const;
